import { useNavigate } from 'react-router-dom';

import { useConsentimento as useConsentimentoDoNucleo } from '@maestra/core/telas/auth/useConsentimento';

// A MAIORIDADE E O ACEITE (LGPD): a regra mora no núcleo desde 01/11/2026, e o app usa a mesma
// (docs/PLANO-APP-NATIVO.md). A web entrega o `navigate`.

export const useConsentimento = () => useConsentimentoDoNucleo({ ir: useNavigate() });

export { IDADE_MINIMA } from '@maestra/core/telas/auth/useConsentimento';
